import { create } from '@thoughtspot/logger';
import { TSToChartEvent } from '@thoughtspot/ts-chart-sdk';
import { ErrorTypes } from '../../../components/chart-error/chart-error.helper';
import { sendMessage } from '../../../services/post-message-event-dispatcher';
const logger = create('ts-to-chart > event-callbacks > download-xlsx-triggered');
export const triggerDownloadXlsx = (commonProps, eventProps) => {
    const { iFrameWindow: iframeRef, appUrl } = commonProps;
    return sendMessage(iframeRef, {
        eventType: TSToChartEvent.DownloadExcelTrigger,
        payload: eventProps,
    }, appUrl)
        .then(res => {
        return res?.data ?? null;
    })
        .catch(err => {
        if (err.errorType === ErrorTypes.MESSAGE_TIMEOUT_ERROR) {
            logger.warn('Taking too long to download excel...');
        }
        else {
            logger.error('Error in Downloading Excel', err);
            throw err;
        }
    });
};
//# sourceMappingURL=index.js.map